import CloseButtonIcon from "@components/Shared/CloseButtonIcon";
import defaultImage from "@images/shared/profile-default.png";
import { ReactElement } from "react";
import styles from "./BoxImage.module.scss";

export interface IBoxImage {
  title?: string;
  urlImage?: string;
  altImage?: string;
  isPreview?: boolean;
  onRemove?: () => void;
}

const BoxImage = ({
  title,
  urlImage,
  altImage,
  isPreview = false,
  onRemove,
}: IBoxImage): ReactElement => (
  <>
    {title && <label className="form__form-group-label">{title}</label>}
    <div
      className={`${styles.box__image} ${isPreview ? styles.isPreview : ""}`}
    >
      <img
        src={urlImage ?? defaultImage}
        alt={altImage ?? "image preview"}
        onError={(event) => (event.currentTarget.src = defaultImage)}
      />
      {isPreview && <CloseButtonIcon onRemove={onRemove} />}
    </div>
  </>
);

export default BoxImage;
